// Added by Sejune Oh on 2019-09-30
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { CustomColumnElementProps } from './CustomColumnSchemaStore'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetStudyCustomColumns = async (proxy_token: string, path: string = '') => {
    return await axios.get<GetQueryReturn<CustomColumnElementProps>>(
        `/v1/data/${proxy_token}/config/custom-columns-schema?${path}`
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetSutdyCustomColumnProps extends CustomColumnElementProps { }
export const reqGetStudyCustomColumn = async (proxy_token: string, id: string) => {
    return await axios.get<ResGetSutdyCustomColumnProps>(`/v1/data/${proxy_token}/config/custom-columns-schema/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateCustomColumnProps extends CustomColumnElementProps { }
export const reqCreateStudyCustomColumn = async (
    proxy_token: string,
    customColumnElementProps: CustomColumnElementProps
) => {
    return await axios.post<ResCreateCustomColumnProps>(`/v1/data/${proxy_token}/config/custom-columns-schema`, {
        ...customColumnElementProps,
    })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateStudyCustomColumn extends CustomColumnElementProps { }
export const reqUpdateStudyCustomColumn = async (
    proxy_token: string,
    id: string,
    customColumnElementProps: CustomColumnElementProps
) => {
    return await axios.put<ResUpdateStudyCustomColumn>(`/v1/data/${proxy_token}/config/custom-columns-schema/${id}`, {
        ...customColumnElementProps,
    })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteStudyCustomColumn = async (proxy_token: string, id: string) => {
    return await axios.delete(`/v1/data/${proxy_token}/config/custom-columns-schema/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetPredefinedCustomColumnsSchema = async () => {
    return await axios.get<GetQueryReturn<CustomColumnElementProps>>(
        '/v1/data/config/pre-defined-custom-columns-schema'
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetStudyResultValueType {
    key: string
    value_type: string
}
export const reqGetStudyResultValueType = async (proxy_token: string, key: string) => {
    return await axios.get<ResGetStudyResultValueType>(`/v1/data/${proxy_token}/dcm/studies/results/${key}`)
}
